import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getCurrentRegion,
  getRegions,
} from "../../store/order";
import { regionChanged } from "../../store/order/orderSlice";
import { receiveOrderByShopAndRegion } from "../../store/order/actions";

function ShopRegionList({ shop }) {
  const regionList = useSelector(getRegions(shop));
  const currentRegion = useSelector(getCurrentRegion(shop));
  const dispatch = useDispatch();

  const handleChangeRegion = (value) => {
    dispatch(regionChanged({ shop, region: value }));
    dispatch(receiveOrderByShopAndRegion(shop, { params: { regionType: value } }));
  };

  if (!regionList || regionList.length === 0) {
    return null;
  }

  return (
        <div className="w-full">
          <p className="shop-region-label">Выберите регион:</p>
          <div className="shop-region-list">
            {regionList?.map((reg) => (
              <button
                className={
                  "shop-region-button " +
                  (currentRegion === reg.cardRegionCd
                    ? "shop-region-button-active"
                    : "")
                }
                disabled={currentRegion === reg.cardRegionCd}
                key={reg.cardRegionCd}
                onClick={() => handleChangeRegion(reg.cardRegionCd)}
              >
                {reg.cardRegionCd} ( {reg.regionCaption} )
              </button>
            ))}
          </div>
        </div>
  );
}

export default ShopRegionList;
